import { Spacer } from '@nextui-org/react';
import React, { useEffect, useState } from 'react';
import CheckEtiquetaScreen from './components/CheckEtiquetaScreen/CheckEtiquetaScreen';
import PrintOrderTagModal from './components/PrintOrderTagModal/PrintOrderTagModal';
import useCheckOrders from './hooks/useCheckOrders';

const CheckOrders = (): JSX.Element => {
  const {
    disableAutoSubmit,
    setDisableAutoSubmit,
    submitToPrinter,
    theme,
    navigate,
    setNfKey,
    nfKey,
    printModalRef,
    addPrintedOrder,
    printedOrdersArray,
    openModalWithTag,
    tipoCarga,
    setTipoCarga,
  } = useCheckOrders();
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIfMobile = (): void => {
      setIsMobile(window.matchMedia('(max-width: 1024px)').matches);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return (
    <div>
      <p
        className={`${
          isMobile ? 'text-xs' : 'text-mds'
        } font-semibold text-default-800`}
      >
        Certifique de ter a impressora conectada ou instalada e definida como
        padrão! Isso pode fazer com que seja impressa em uma impressora
        diferente ou pior que nao seja impressa.
      </p>
      <Spacer y={12} />
      {/* SHOW ETIQUETA SCREEN */}

      <CheckEtiquetaScreen
        disableAutoSubmit={disableAutoSubmit}
        setDisableAutoSubmit={setDisableAutoSubmit}
        submitToPrinter={submitToPrinter}
        theme={theme}
        navigate={navigate}
        setNfKey={setNfKey}
        nfKey={nfKey}
        printModalRef={printModalRef}
        addPrintedOrder={addPrintedOrder}
        printedOrdersArray={printedOrdersArray}
        openModalWithTag={openModalWithTag}
        isMobile={isMobile}
        tipoCarga={tipoCarga}
        setTipoCarga={setTipoCarga}
      />

      {/* Print Tag Modal */}
      <PrintOrderTagModal
        tipoCarga={tipoCarga}
        ref={printModalRef}
        resetNfeKeyField={() => setNfKey('')}
        etiqueta={nfKey}
      />

      <Spacer y={12} />
    </div>
  );
};

export default CheckOrders;
